import './ProductDetails.css';
import mainImage from '../../img/product-detail-image-main.svg';
import secImageOne from '../../img/product-detail-image-1.svg';
import secImageTwo from '../../img/product-detail-image-2.svg';
import secImageThree from '../../img/product-detail-image-3.svg';
import secImageFour from '../../img/product-detail-image-4.svg';
import imgMaudy from '../../img/foto-maudy.svg';
import locationPin from '../../img/location-icon.svg';
import ongkirIcon from '../../img/estimasi-ongkir.svg';
import courierWarningIcon from '../../img/warning-courier-icon.svg';
import saveButton from '../../img/save-icon.svg';
import chatButton from '../../img/chat-icon.svg';
import buyButton from '../../img/buy-now-icon.svg';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import nl2br from 'react-newline-to-break';
import { useHistory} from 'react-router-dom';

const ProductDetails = (data) => {

    const { category, discount, id, imageUrl, price, productInformation, productName, sellerName, sellerId, sellerPhoneNumber } = data.data;

    const [citCetURL, setCitCetURL] = useState("");
    const sessionId = localStorage.getItem("sessionId");
    const history = useHistory();

    const formatNumber = (n, p, ts, dp) => {
        var t = [];
        // Get arguments, set defaults
        if (typeof p  == 'undefined') p  = 0;
        if (typeof ts == 'undefined') ts = '.';
        if (typeof dp == 'undefined') dp = ',';
      
        // Get number and decimal part of n
        n = Number(n).toFixed(p).split('.');
      
        // Add thousands separator and decimal point (if requied):
        for (var iLen = n[0].length, i = iLen? iLen % 3 || 3 : 0, j = 0; i <= iLen; i+=3) {
          t.push(n[0].substring(j, i));
          j = i;
        }
        // Insert separators and return result
        return t.join(ts) + (n[1]? dp + n[1] : '');
      }

    const fetchChatLink = async () => {

        let userId = localStorage.getItem("userId");
        let userFullName = localStorage.getItem("userFullName");
        console.log(userId)
        console.log(userFullName)


        const chatData = JSON.stringify({
            senderId: userId.toString(),
            senderName: userFullName.toString(),
            receiverId: sellerId.toString(),
            receiverName: sellerName.toString()
        })

        const response = await fetch("https://citcet-app.herokuapp.com/room", {
            method: "POST",
            body: chatData,
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        })
            .then(res => res.json())
            .then(res => {
                Swal.fire({
                    title: 'Anda akan dialihkan CitCet App.',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#0476D0',
                    confirmButtonText: 'OK'
                  }).then((result) => {
                    if (result.isConfirmed) {
                        window.open("https://citcet-app.herokuapp.com" + res.url, "_blank");
                    }
                  })
                
            })
    }

    const handleChatButton = () => {
        if(sessionId){
            fetchChatLink();
        } else {
            Swal.fire({
                text: 'Mohon login sebelum menggunakan fitur chat',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#0476D0',
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                    history.push("/login")
                }
              })
        }
    }

    return (
        <>
            <div className="productdetails-wrapper">
                <div className="productdetails-productdetail">
                    <div className="productdetails-productimagewrapper">
                        <div className="productimage-mainimage-wrapper">
                            <img id="product-image-mainimage" src={imageUrl}></img>
                        </div>
                    </div>
                    <div className="productdetails-productinfowrapper">
                        <h2 className="productdetails-productname">{productName}</h2>
                        <h2 className="productdetails-productprice">Rp{formatNumber(price)}</h2>
                        <div className="productdetails-productsetterwrapper">
                            <img src={imgMaudy}></img>
                            <div className="productdetails-detailedinfowrapper">
                                <h5 id="productdetails-productsetter">{sellerName}</h5>
                                <h6 id="productdetails-mobilenumber">+6282345567890</h6>
                            </div>
                        </div>
                        <div className="productdetails-sectionbreak"></div>
                        <div className="productdetails-address-wrapper">
                            <img src={locationPin}></img>
                            <h4 className="productdetails-address">
                                Dikirim dari <span className="product-details-address-bold">Pogung Baru, Yogyakarta</span>
                            </h4>
                        </div>
                        <div className="productdetails-costestimation-wrapper">
                            <img src={ongkirIcon}></img>
                            <h4 className="productdetails-costestimation">
                                Estimasi ongkir <span className="product-details-cost-bold">Rp35.000</span>
                            </h4>
                        </div>
                        <div class="courier-warning-img">
                            <img src={courierWarningIcon}></img>
                            <h4>
                            Perhatian!. Dilarang keras membentak kurir ketika datang mengirimkan barang Anda! Mari jaga solidaritas bersama.
                            </h4>
                        </div>
                        <div className="productdetails-sectionbreak"></div>
                        <div className="productdetails-buttonwrapper">
                            <div className="productdetails-savebtn">
                                <img src={saveButton}></img>
                                <h4 className="product-details-savetext">Save</h4>
                            </div>
                            <div></div>
                            <div onClick={handleChatButton} className="productdetails-chatbtn">
                                <img src={chatButton}></img>
                                <h4 className="product-details-chattext">Chat</h4>
                            </div>
                            <div></div>
                            <div onClick={data.onClick} className="productdetails-buybtn">
                                <img src={buyButton}></img>
                                <h4 className="product-details-buytext">Beli Sekarang</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="productdetails-productinformation">
                    <h4 className="productdetails-productinformationtitle">
                        Product Information
                </h4>
                    <div className="productinformation-sectionbreak"></div>
                    <p>{nl2br(productInformation)}</p>
                </div>
            </div>
        </>
    )

    // return(
    //     <div className="productdetails-wrapper">
    //         <div className="productdetails-productdetail">
    //             <div className="productdetails-productimagewrapper">
    //                 <div className="productimage-mainimage-wrapper">
    //                     <img src={mainImage}></img>
    //                 </div>
    //                 <div className="productimage-secondary-wrapper">
    //                     <img src={secImageOne}></img>
    //                     <img src={secImageTwo}></img>
    //                     <img className="productimage-active-image" src={secImageThree}></img>
    //                     <img src={secImageFour}></img>
    //                 </div>
    //             </div>
    //             <div className="productdetails-productinfowrapper">
    //                 <h2 className="productdetails-productname">Nike Airmax 270 React</h2>
    //                 <h2 className="productdetails-productprice">Rp3000000</h2>
    //                 <div className="productdetails-productsetterwrapper">
    //                     <img src={imgMaudy}></img>
    //                     <div className="productdetails-detailedinfowrapper">
    //                         <h5 id="productdetails-productsetter">Maudy Salsabila Ayunda</h5>
    //                         <h6 id="productdetails-mobilenumber">+6282345567890</h6>
    //                     </div>
    //                 </div>
    //                 <div className="productdetails-sectionbreak"></div>
    //                 <div className="productdetails-address-wrapper">
    //                         <img src={locationPin}></img>
    //                         <h4 className="productdetails-address">
    //                         Dikirim dari <span className="product-details-address-bold">Pogung Baru, Yogyakarta</span>
    //                         </h4>
    //                 </div>
    //                 <div className="productdetails-costestimation-wrapper">
    //                         <img src={ongkirIcon}></img>
    //                         <h4 className="productdetails-costestimation">
    //                         Estimasi ongkir <span className="product-details-cost-bold">Rp35.000</span>
    //                         </h4>
    //                 </div>
    //                 <div class="courier-warning-img">
    //                     <img src={courierWarning}></img>
    //                 </div>
    //                 <div className="productdetails-sectionbreak"></div>
    //                 <div className="productdetails-buttonwrapper">
    //                     <div className="productdetails-savebtn">
    //                         <img src={saveButton}></img>
    //                         <h4 className="product-details-savetext">Save</h4>
    //                     </div>
    //                     <div></div>
    //                     <div className="productdetails-chatbtn">
    //                         <img src={chatButton}></img>
    //                         <h4 className="product-details-chattext">Chat</h4>
    //                     </div>
    //                     <div></div>
    //                     <div className="productdetails-buybtn">
    //                         <img src={buyButton}></img>
    //                         <h4 className="product-details-buytext">Buy This Item Now</h4>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //         <div className="productdetails-productinformation">
    //             <h4 className="productdetails-productinformationtitle">
    //                 Product Information
    //             </h4>
    //             <div className="productinformation-sectionbreak"></div>
    //             <p>
    //             Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel pharetra vel turpis nunc. Est sit amet facilisis magna etiam tempor orci. A condimentum vitae sapien pellentesque habitant. Dignissim sodales ut eu sem integer vitae justo. Pellentesque pulvinar pellentesque habitant morbi tristique senectus et. Morbi tincidunt ornare massa eget egestas. Felis eget nunc lobortis mattis aliquam faucibus purus. Non nisi est sit amet facilisis magna etiam tempor orci. Nulla malesuada pellentesque elit eget. Blandit cursus risus at ultrices mi tempus imperdiet. Ultricies tristique nulla aliquet enim tortor at auctor urna nunc. Blandit aliquam etiam erat velit scelerisque in dictum non. Nisl nisi scelerisque eu ultrices. In egestas erat imperdiet sed euismod nisi porta lorem mollis. Ac auctor augue mauris augue neque gravida in fermentum. Cras pulvinar mattis nunc sed blandit. Odio ut enim blandit volutpat maecenas volutpat blandit aliquam. A scelerisque purus semper eget duis at tellus at urna.
    //             </p>
    //             <p>
    //             Montes nascetur ridiculus mus mauris vitae ultricies leo. Id volutpat lacus laoreet non curabitur gravida arcu ac. Fermentum et sollicitudin ac orci phasellus egestas. Aenean vel elit scelerisque mauris pellentesque pulvinar pellentesque habitant morbi. Venenatis a condimentum vitae sapien. Nunc non blandit massa enim. A arcu cursus vitae congue mauris. Vel risus commodo viverra maecenas accumsan lacus vel facilisis. Risus at ultrices mi tempus imperdiet. Tincidunt praesent semper feugiat nibh sed pulvinar proin. Elementum integer enim neque volutpat ac. Facilisis gravida neque convallis a cras semper auctor. Etiam non quam lacus suspendisse faucibus interdum posuere lorem. Dignissim convallis aenean et tortor at risus. Lectus arcu bibendum at varius vel pharetra vel. Condimentum vitae sapien pellentesque habitant morbi tristique. Aliquam vestibulum morbi blandit cursus risus at ultrices mi. Quis imperdiet massa tincidunt nunc pulvinar sapien et. Sit amet nulla facilisi morbi.
    //             </p>
    //         </div>
    //     </div>
    // )
};

export default ProductDetails;